import { Component } from '@angular/core';
import { NumberFieldComponent } from './number-field.component';

@Component( {
    selector: 'erp-pbw-prozent',
    templateUrl: './number-field.component.html'
} )
export class DisabilityValueComponent extends NumberFieldComponent {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.disabilityInPercent',
            { min: 0, max: 100, minFractionDigits: 0, maxFractionDigits: 0 }
        );
    }

    set value( t: number | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.disabilityInPercent = t;
        }
    }

    get value(): number | undefined {
        return this.jobapplication?.disabilityInPercent;
    }
}
